import React from 'react';

import { FlexColumn } from 'ui-components/components/flex';
import { RestrictedShipmentBannerMessage } from '../../../../../fulfillment-planner/restricted-shipment-config/restricted-shipment-banner-message';
import fieldStyle from '../fields.module.less';

export const RestrictedShipmentBanner = () => (
  <FlexColumn className={fieldStyle['field-content']}>
    <RestrictedShipmentBannerMessage />
  </FlexColumn>
);
